// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"272":"admin-login","605":"shop-verify-success","806":"user","883":"shop","884":"admin"}[chunkId] || chunkId) + "." + {"272":"dbccdd9d","417":"b77c2ab0","605":"8a02f8a9","731":"d12971e0","806":"8fc0f99b","883":"f1cd446d","884":"a27865d7"}[chunkId] + ".js";
};